import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { CustomResponseDto } from '@core/model/custom-response-dto';
import { SystemConfigurationDto } from '@core/model/system-configuration-dto';

@Injectable()
export class EmailVerificationService {
  private apiUrl = environment.apiUrl;
  private getAccountByEmailUrl = `${this.apiUrl}origination/originations/exists-account-by-email/{email}`;
  private validateEmailUrl = `${this.apiUrl}origination/originations/validate-email-address/{emailAddress}`;
  private configurationUrl = `${this.apiUrl}systemconfig/search/key/{key}`;
  // private emailMatchingUrl = `${this.apiUrl}user/user_account/emailMatching/{email}/{confirmEmail}`;
  private emailMatchingUrl = `${this.apiUrl}origination/originations/email-matching/{email}/{reEmail}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public accountExistsByEmail(email: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(this.getAccountByEmailUrl.replace('{email}', email), { headers: this.headers });
  }

  public verifyEmailMatching(email: string, confirmEmail: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(this.emailMatchingUrl.replace('{email}', email).replace('{reEmail}', confirmEmail), {
      headers: this.headers,
    });
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }

  public validateEmail(emailAddress: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(this.validateEmailUrl.replace('{emailAddress}', emailAddress), { headers: this.headers });
  }

  public getEmailMismatchMsg(key: string): Observable<SystemConfigurationDto> {
    return this.http.get<any>(this.configurationUrl.replace('{key}', key), { headers: this.headers }).pipe(
      map((value: CustomResponseDto<SystemConfigurationDto>) => {
        if (value.message == 'OK') {
          return value.response[0];
        } else {
          let ret: SystemConfigurationDto;
          ret.value = 'Los correos no coinciden';
          return ret;
        }
      })
    );
  }
}
